<template>
  <div class="login-page">
    <div class="login-container">
      <!-- ===== 左侧品牌区 ===== -->
      <div class="login-brand">
        <div class="brand-content">
          <div class="brand-logo">
            <router-link :to="{ name: 'index' }">
              <img src="@/assets/logo_pc2.png" alt="ReelShortPro" />
            </router-link>
            <!-- <span class="logo-icon">▶</span>
            <span class="logo-text">ReelShortPro</span> -->
          </div>
          <h1 class="brand-title" v-if="step == 1">{{ $t('_dl._hy') }}</h1>
          <h1 class="brand-title" v-else-if="step == 2">{{ $t('_dl._cj') }}</h1>
          <h1 class="brand-title" v-else>{{ $t('_dl._zmm') }}</h1>
          <p class="brand-desc" v-if="step == 1">{{ $t('_dl._hyDesc') }}</p>
          <p class="brand-desc" v-else-if="step == 2">{{ $t('_dl._cjDesc') }}</p>
          <p class="brand-desc" v-else>{{ $t('_dl._zmmDesc') }}</p>
          <div class="brand-features">
            <div class="feature-item">
              <span class="feature-dot"></span>
              <span>{{ $t('_dl._hlgqsp') }}</span>
            </div>
            <div class="feature-item">
              <span class="feature-dot"></span>
              <span>{{ $t('_dl._gxhty') }}</span>
            </div>
            <div class="feature-item">
              <span class="feature-dot"></span>
              <span>{{ $t('_dl._ffddsp') }}</span>
            </div>
          </div>
        </div>
        <div class="brand-footer">
          <span>© 2026 ReelShortPro. All rights reserved.</span>
        </div>
      </div>

      <!-- ===== 右侧表单区 ===== -->
      <div class="login-form">
        <!-- 登录 -->
        <div class="form-panel" v-if="step == 1">
          <div class="form-header">
            <h2 class="form-title">{{ $t('_dl._dlzh') }}</h2>
            <p class="form-subtitle">{{ $t('_dl._sdndyx') }}</p>
          </div>

          <div class="form-body">
            <div class="input-group">
              <label class="input-label">{{ $t('_dl._email') }}</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <input class="form-input" v-model="signin.email" type="text" :placeholder="$t('_dl._qsryx')" />
              </div>
            </div>

            <div class="input-group">
              <label class="input-label">{{ $t('_dl._dlmm') }}</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
                <input class="form-input" v-model="signin.passwd" type="password" :placeholder="$t('_dl._qsrmm')" />
              </div>
            </div>

            <!-- 忘记密码 -->
            <div class="forgot-password">
              <a @click="step = 3">{{ $t('_dl._wjmm') }}</a>
            </div>

            <button class="btn-primary" @click="onLoginSubmit">
              <span>{{ $t('_dl._immdl') }}</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12,5 19,12 12,19" />
              </svg>
            </button>

            <div class="form-footer">
              <span>{{ $t('_dl._hmyzh2') }}</span>
              <a @click="onSignup">{{ $t('_dl._ljzc2') }} →</a>
            </div>
          </div>
        </div>

        <!-- 注册 -->
        <div class="form-panel" v-if="step == 2">
          <div class="form-header">
            <h2 class="form-title">{{ $t('_dl._cjzh') }}</h2>
            <p class="form-subtitle">{{ $t('_dl._jswmd') }}</p>
          </div>

          <div class="form-body">
            <div class="input-group">
              <label class="input-label">{{ $t('_dl._email') }}</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <input class="form-input" v-model="signup.email" type="text" :placeholder="$t('_dl._qsryx')" />
              </div>
            </div>

            <div class="input-group">
              <label class="input-label">{{ $t('_dl._dlmm') }}</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
                <input class="form-input" v-model="signup.passwd" type="password" :placeholder="$t('_zh._qszmm')" />
              </div>
            </div>

            <div class="input-group">
              <label class="input-label">{{ $t('_zh._qrmm') }}</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
                <input class="form-input" v-model="signup.confirm_passwd" type="password" :placeholder="$t('_zh._qrmm')" />
              </div>
            </div>

            <div class="input-group" v-if="inv_code_show">
              <label class="input-label">{{ $t('_zc._yqm') }}</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z" />
                  <path d="M2 17l10 5 10-5" />
                  <path d="M2 12l10 5 10-5" />
                </svg>
                <input class="form-input" v-model="signup.inv_code" type="text" :placeholder="$t('_zc._sryqm')" />
              </div>
            </div>

            <div class="input-group">
              <label class="input-label">{{ $t('_dl._yzm') }}</label>
              <div class="input-wrapper code-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12,6 12,12 16,14" />
                </svg>
                <input class="form-input code-input" v-model="signup.code" type="text" :placeholder="$t('_dl._qsryzm')" />
                <button class="code-btn" @click="onSendCode()" :disabled="!hasSend">{{ codeBtnText }}</button>
              </div>
            </div>

            <button class="btn-primary" @click="onSignupSubmit">
              <span>{{ $t('_dl._ljzc2') }}</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12,5 19,12 12,19" />
              </svg>
            </button>

            <div class="form-footer">
              <span>{{ $t('_dl._yjyzh') }}</span>
              <a @click="onLogin">{{ $t('_dl._immdl') }} →</a>
            </div>
            <div class="form-terms">
              <span>{{ $t('_dl._zcbsty2') }}</span>
              <a href="/privacyPolicy">{{ $t('_dl._zcbstyDesc') }}</a>
            </div>
          </div>
        </div>

        <!-- 忘记密码 / 重置密码 -->
        <div class="form-panel" v-if="step == 3">
          <div class="form-header">
            <h2 class="form-title">{{ $t('_dl._zmm') }}</h2>
            <p class="form-subtitle">{{ $t('_dl._zmmDesc') }}</p>
          </div>

          <div class="form-body">
            <div class="input-group">
              <label class="input-label">{{ $t('_dl._email') }}</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <input class="form-input" v-model="reset.email" type="text" :placeholder="$t('_dl._qsryx')" />
              </div>
            </div>

            <div class="input-group">
              <label class="input-label">{{ $t('_dl._yzm') }}</label>
              <div class="input-wrapper code-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12,6 12,12 16,14" />
                </svg>
                <input class="form-input code-input" v-model="reset.code" type="text" :placeholder="$t('_dl._qsryzm')" />
                <button class="code-btn" @click="onSendResetCode()" :disabled="!hasResetSend">{{ resetBtnText }}</button>
              </div>
            </div>

            <div class="input-group">
              <label class="input-label">{{ $t('_dl._newmm') }}</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
                <input class="form-input" v-model="reset.new_passwd" type="password" :placeholder="$t('_dl._qszxmm')" />
              </div>
            </div>

            <div class="input-group">
              <label class="input-label">{{ $t('_dl._qrmm') }}</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
                <input class="form-input" v-model="reset.confirm_passwd" type="password" :placeholder="$t('_dl._qzcsrmm')" />
              </div>
            </div>

            <button class="btn-primary" @click="onResetSubmit">
              <span>{{ $t('_dl._czmm') }}</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12,5 19,12 12,19" />
              </svg>
            </button>

            <div class="form-footer">
              <span>{{ $t('_dl._xqlmm') }}</span>
              <a @click="step = 1">{{ $t('_dl._fhdl') }} →</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { countdown } from '@/utils/tools'
export default {
  name: 'LoginVue',
  data() {
    return {
      step: 1,
      signin: {
        email: '',
        passwd: ''
      },
      hasSend: true,
      codeBtnText: this.$t('_yzm._fsyzm'),
      inv_code_show: true,
      signup: {
        email: '',
        passwd: '',
        confirm_passwd: '',
        inv_code: '',
        code: '',
        inv_uid: '',
        gift_code: '',
        gift_uuid: ''
      },
      // 重置密码
      reset: {
        email: '',
        code: '',
        new_passwd: '',
        confirm_passwd: ''
      },
      hasResetSend: true,
      resetBtnText: this.$t('_yzm._fsyzm')
    }
  },
  created() {
    let type = this.$route.query.type
    let inv_code = this.$route.query.code
    if (type == 'invite') {
      this.step = 2
      this.signup.inv_code = inv_code
      this.inv_code_show = false
    }

    let t = this.$route.query.t
    if (t == 'register') {
      this.step = 2
    }
  },
  methods: {
    // show(v, inv_code, gift_code, gift_uuid) {
    //   if (v) this.step = v
    //   if (inv_code) {
    //     this.signup.inv_code = inv_code
    //     this.inv_code_show = false
    //   }
    //   if (gift_code && gift_uuid) {
    //     this.signup.gift_code = gift_code
    //     this.signup.gift_uuid = gift_uuid
    //   }
    // },
    onLogin() {
      this.step = 1
    },
    onSignup() {
      this.step = 2
    },
    validSignin() {
      if (!this.signin.email) {
        this.$message.error(this.$t('_dl._qssyx'))
        return false
      }
      if (!this.signin.passwd) {
        this.$message.error(this.$t('_dl._qssmm'))
        return false
      }
      return true
    },
    onLoginSubmit() {
      if (!this.validSignin()) return
      this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })
      this.$api.user
        .signin(this.signin)
        .then((res) => {
          if (res.code !== 0) {
            this.$message.error({ content: res.msg, key: 'msg' })
            return
          }
          localStorage.setItem(this.$Const.KEY_TOKEN, res.data.token)
          localStorage.setItem(this.$Const.KEY_INFO, JSON.stringify(res.data.info))
          this.$message.success({ content: res.msg, key: 'msg' })
          this.$emit('signinSuccess')
          window.location.href = '/'
        })
        .catch(() => {})
    },
    onSendCode() {
      if (!this.signup.email) {
        this.$message.error(this.$t('_dl._qsryx'))
        return
      }
      if (!this.hasSend) return
      let email = this.$common.rmSpaces(this.signup.email)
      let key = this.$md5(email)
      this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })
      this.$api.code.sendCode({ email: email, scene: 'signup' }).then((res) => {
        this.$message.success({ content: this.$t('_yzm._fscg'), key: 'msg' })
        countdown.start(key, res.data.exp)
        countdown.run(key, this.CallTime)
      })
    },
    CallTime(time) {
      if (time == 0) {
        this.hasSend = true
        this.codeBtnText = this.$t('_yzm._fsyzm')
      } else {
        this.hasSend = false
        this.codeBtnText = this.$t('_yzm._cxfs', { time: time })
      }
    },
    validSignup() {
      console.log(this.signup,"validSignup")
      if (!this.signup.email) {
        this.$message.error(this.$t('_dl._qssyx'))
        return false
      }
      if (!this.signup.passwd) {
        this.$message.error(this.$t('_dl._qssmm'))
        return false
      }
      if (this.signup.passwd !== this.signup.confirm_passwd) {
        this.$message.error(this.$t('_dl._lcmmbyy'))
        return false
      }
      if (!this.signup.inv_code) {
        this.$message.error(this.$t('_dl._sryqm'))
        return false
      }
      if (!this.signup.code) {
        this.$message.error(this.$t('_dl._sryzm'))
        return false
      }
      return true
    },
    onSignupSubmit() {
      if (!this.validSignup()) return
      this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })
      this.$api.user
        .signup(this.signup)
        .then((res) => {
          if (res.code !== 0) {
            this.$message.error({ content: res.msg, key: 'msg' })
            return
          }
          this.$message.success({ content: res.msg, key: 'msg' })
          this.onLogin()
          this.$emit('signupSuccess')
        })
        .catch(() => {})
    },
    // ===== 重置密码 =====
    onSendResetCode() {
      if (!this.hasResetSend) return
      let email = this.$common.rmSpaces(this.reset.email)
      if (!email) {
        this.$message.error(this.$t('_dl._qsryx'))
        return
      }
      let key = this.$md5(email + '_reset')
      this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })
      this.$api.code.sendCode({ email: email, scene: 'forget' }).then((res) => {
        this.$message.success({ content: this.$t('_yzm._fscg'), key: 'msg' })
        countdown.start(key, res.data.exp)
        countdown.run(key, this.ResetCallTime)
      })
    },
    ResetCallTime(time) {
      if (time == 0) {
        this.hasResetSend = true
        this.resetBtnText = this.$t('_yzm._fsyzm')
      } else {
        this.hasResetSend = false
        this.resetBtnText = this.$t('_yzm._cxfs', { time: time })
      }
    },
    validReset() {
      if (!this.reset.email) {
        this.$message.error(this.$t('_dl._qsryx'))
        return false
      }
      if (!this.reset.code) {
        this.$message.error(this.$t('_dl._sryzm'))
        return false
      }
      if (!this.reset.new_passwd) {
        this.$message.error(this.$t('_dl._qszxmm'))
        return false
      }
      if (this.reset.new_passwd !== this.reset.confirm_passwd) {
        this.$message.error(this.$t('_dl._srdllmmbyz'))
        return false
      }
      return true
    },
    onResetSubmit() {
      if (!this.validReset()) return
      this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })
      this.$api.user
        .forgetPwd({
          email: this.reset.email,
          code: this.reset.code,
          passwd: this.reset.new_passwd
        })
        .then((res) => {
          if (res.code !== 0) {
            this.$message.error({ content: res.msg, key: 'msg' })
            return
          }
          this.$message.success({ content: res.msg || this.$t('_dl._czcg'), key: 'msg' })
          this.step = 1
          this.reset = { email: '', code: '', new_passwd: '', confirm_passwd: '' }
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
/* ============================================================
   登录页面 - 大气深色主题
   ============================================================ */

.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0b0d0f;
  padding: 20px;
}

.login-container {
  display: flex;
  width: 880px;
  max-width: 100%;
  max-height: 92vh;
  background: #1a1f26;
  border-radius: 24px;
  border: 1px solid #2a3038;
  box-shadow: 0 40px 120px rgba(0, 0, 0, 0.6);
  overflow: hidden;
}

/* ============================================================
   左侧品牌区
   ============================================================ */
.login-brand {
  flex: 0 0 380px;
  padding: 48px 40px 32px;
  background: linear-gradient(145deg, #0a0d0f, #14181c);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.brand-content {
  flex: 1;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 32px;
}
.logo-icon {
  font-size: 28px;
  color: #ffb300;
}
.logo-text {
  font-size: 24px;
  font-weight: 700;
  color: #e8edf2;
  letter-spacing: 1px;
}

.brand-title {
  font-size: 28px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0 0 8px;
}
.brand-desc {
  font-size: 15px;
  color: #8a949f;
  margin: 0 0 32px;
  line-height: 1.6;
}

.brand-features {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #b0bcc8;
}
.feature-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffb300;
  flex-shrink: 0;
}

.brand-footer {
  font-size: 12px;
  color: #3a4652;
  padding-top: 20px;
  border-top: 1px solid #2a3038;
}

/* ============================================================
   右侧表单区
   ============================================================ */
.login-form {
  flex: 1;
  padding: 48px 44px 40px;
  overflow-y: auto;
  background: #1a1f26;
}
.login-form::-webkit-scrollbar {
  width: 3px;
}
.login-form::-webkit-scrollbar-thumb {
  background: #2a3038;
  border-radius: 4px;
}

.form-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.form-header {
  margin-bottom: 28px;
}
.form-title {
  font-size: 24px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0 0 4px;
}
.form-subtitle {
  font-size: 14px;
  color: #6a7a8a;
  margin: 0;
}

.form-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ============================================================
   输入框
   ============================================================ */
.input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.input-label {
  font-size: 13px;
  font-weight: 500;
  color: #8a949f;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.input-icon {
  position: absolute;
  left: 14px;
  width: 18px;
  height: 18px;
  color: #4a5662;
  pointer-events: none;
}

.form-input {
  width: 100%;
  height: 48px;
  padding: 0 14px 0 44px;
  background: #0a0d0f;
  border: 1.5px solid #2a3038;
  border-radius: 12px;
  color: #e8edf2;
  font-size: 15px;
  outline: none;
  transition: all 0.3s ease;
}
.form-input:focus {
  border-color: #ffb300;
  box-shadow: 0 0 0 4px rgba(255, 179, 0, 0.06);
}
.form-input::placeholder {
  color: #4a5662;
}

/* 验证码 */
.code-wrapper .code-input {
  padding-right: 110px;
}
.code-btn {
  position: absolute;
  right: 6px;
  padding: 0 18px;
  height: 38px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 179, 0, 0.1);
  color: #ffb300;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}
.code-btn:hover:not(:disabled) {
  background: rgba(255, 179, 0, 0.18);
}
.code-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================================
   忘记密码
   ============================================================ */
.forgot-password {
  text-align: right;
  margin-top: -6px;
}
.forgot-password a {
  font-size: 13px;
  color: #5a6672;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s;
}
.forgot-password a:hover {
  color: #ffb300;
}

/* ============================================================
   按钮
   ============================================================ */
.btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 30px;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 4px;
}
.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(255, 179, 0, 0.25);
}
.btn-primary:active {
  transform: scale(0.97);
}
.btn-primary svg {
  width: 20px;
  height: 20px;
  stroke: currentColor;
}

/* ============================================================
   底部链接
   ============================================================ */
.form-footer {
  text-align: center;
  font-size: 14px;
  color: #6a7a8a;
  margin-top: 4px;
}
.form-footer a {
  color: #ffb300;
  cursor: pointer;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s;
}
.form-footer a:hover {
  color: #ffca28;
}

.form-terms {
  text-align: center;
  font-size: 13px;
  color: #4a5662;
  margin-top: 2px;
}
.form-terms a {
  color: #5a6672;
  text-decoration: none;
  transition: color 0.3s;
}
.form-terms a:hover {
  color: #8a949f;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 820px) {
  .login-container {
    flex-direction: column;
    width: 420px;
    max-height: 95vh;
    border-radius: 20px;
  }
  .login-brand {
    flex: 0 0 auto;
    padding: 28px 28px 20px;
    border-bottom: 1px solid #2a3038;
  }
  .brand-logo {
    margin-bottom: 16px;
  }
  .brand-title {
    font-size: 22px;
  }
  .brand-desc {
    font-size: 14px;
    margin-bottom: 16px;
  }
  .brand-features {
    display: none;
  }
  .brand-footer {
    display: none;
  }
  .login-form {
    padding: 28px 24px 24px;
  }
  .form-title {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .login-page {
    padding: 12px;
  }
  .login-container {
    width: 100%;
    border-radius: 16px;
  }
  .login-brand {
    padding: 20px 20px 16px;
  }
  .brand-title {
    font-size: 18px;
  }
  .login-form {
    padding: 20px 16px 20px;
  }
  .form-title {
    font-size: 18px;
  }
  .form-input {
    height: 44px;
    font-size: 14px;
  }
  .btn-primary {
    height: 44px;
    font-size: 15px;
  }
  .code-btn {
    font-size: 12px;
    padding: 0 12px;
    height: 34px;
  }
  .forgot-password a {
    font-size: 12px;
  }
}
</style>
